/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Crosspostingpostedat2Inputs */

const en_crosspostingpostedat2 = /** @type {(inputs: Crosspostingpostedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posted ${i?.date}`)
};

const de_crosspostingpostedat2 = /** @type {(inputs: Crosspostingpostedat2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veröffentlicht ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Posted {date}" |
*
* @param {Crosspostingpostedat2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingpostedat2 = /** @type {((inputs: Crosspostingpostedat2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingpostedat2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingpostedat2(inputs)
	return de_crosspostingpostedat2(inputs)
});
export { crosspostingpostedat2 as "crosspostingPostedAt" }